import { Component, OnInit } from "@angular/core";
import { UtilsService } from "app/auth/service/utils.service";
import { AssetsService } from "../../assets.service";
import { IMyAsset } from "../../models/assets";

@Component({
  selector: "app-my-assets",
  templateUrl: "./my-assets.component.html",
  styleUrls: ["./my-assets.component.scss"],
})
export class MyAssetsComponent implements OnInit {
  public myAssets: IMyAsset[] = [];

  constructor(
    public _assetsService: AssetsService,
    public _utilsService: UtilsService,
  ) {}

  async ngOnInit() {
    this.myAssets = await this._assetsService.getMine();
  }
}
